import {
  CONTEXT_KEY,
  DefaultAtoms,
  DefaultEntities,
  DUMMY_USER_ID,
  type IPublicUserData,
  type UserPublicID,
} from "@atoms/atom-types";
import { __useAtomNext } from "../use-atom/makeUseAtomNext";

/**
 * A hook that returns the default username.
 * This is used to set the username in the Apollo cache.
 * By default, the username is fetched from personaluserdataatom.
 * @returns The default username.
 */
export const __useDefaultUsername = (userId: UserPublicID): string => {
  const { data: personalUserData } = __useAtomNext<IPublicUserData>(
    DefaultAtoms.PersonalUserData,
    {
      extraContext: {
        [CONTEXT_KEY(DefaultEntities.User)]: userId,
      },
      skip: userId === DUMMY_USER_ID,
    },
  );
  return personalUserData?.displayName ?? "unknown user";
};
